import React, { useState } from 'react';
import './Login.css';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom'; // Yönlendirme için
import { auth } from '../firebase/firebase-config';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await signInWithEmailAndPassword(auth, email, password);
      // Giriş başarılıysa admin paneline yönlendir
      navigate('/admin/dashboard'); 
    } catch (err) {
      console.error(err);
      // Hata kodlarına göre mesajları özelleştirebilirsin
      setError('Giriş başarısız. Lütfen bilgilerinizi kontrol edin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-wrapper">
        {/* Sol Taraf: Logo ve Marka Alanı */}
        <div className="login-brand">
          <div className="brand-logo">
            {/* Buraya Arzu Hanım'ın logosu veya baş harfleri gelebilir */}
            <span>AG</span>
          </div>
          <h1>Arzu Gül</h1>
          <p>Hukuk & Danışmanlık</p>
          <small>Yönetim Paneli Girişi</small>
        </div>

        {/* Sağ Taraf: Form Alanı */}
        <div className="login-form-section">
          <h2>Hoş Geldiniz</h2>
          <p className="subtitle">Devam etmek için lütfen giriş yapın.</p>
          
          {error && <div className="error-message">{error}</div>}

          <form onSubmit={handleLogin}>
            <div className="input-group">
              <label htmlFor="email">E-posta Adresi</label>
              <input
                type="email"
                id="email"
                placeholder="ornek@arzugul.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <label htmlFor="password">Şifre</label>
              <input
                type="password"
                id="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? 'Giriş Yapılıyor...' : 'Giriş Yap'}
            </button>
          </form>
          
          <div className="footer-text">
            <p>© 2025 Arzu Gül Hukuk Bürosu</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;